import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import FeeForm from './ModalContent/FeeForm'
import CustomModalFooter from 'components/global/CustomModalFooter'

const FeeModal: React.FC = () => {
  const { handleSubmit, form } = useFormSubmit()
  const { feeModal, setFeeModal, setAdditionalFeeData } = leagueEventStore(
    store => ({
      feeModal: store.feeModal,
      setFeeModal: store.setFeeModal,
      setAdditionalFeeData: store.setAdditionalFeeData,
    }),
  )

  const handleClose = () => {
    setAdditionalFeeData(undefined)
    setFeeModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={feeModal}
        isCloseModalCustom={true}
        closeModal={handleClose}
        title="Additional Fee"
        width={600}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <FeeForm form={form} />
      </CustomModal>
    </>
  )
}

export default FeeModal
